export const categories = [
  {
    name: 'sports',
    image:
      'https://i1.wp.com/pepswork.com/wp-content/uploads/2020/06/fitness-ok.jpg?resize=1024%2C683&ssl=1',
  },
  {
    name: 'websites',
    image:
      'https://academy.avast.com/hubfs/New_Avast_Academy/Is%20this%20website%20safe/Is_this_website_safe-Your_complete_website_safety_check_guide-Hero.png',
  },
  {
    name: 'art',
    image:
      'https://www.letudiant.fr/static/uploads/mediatheque/ETU_ETU/9/5/2428795-adobestock-365376369-766x438.jpeg',
  },
  {
    name: 'peoples',
    image:
      'https://www.quickanddirtytips.com/sites/default/files/styles/article_main_image/public/images/2332/people-persons-peoples.jpg?itok=OXWARzCz',
  },
  {
    name: 'food',
    image:
      'https://assets.afcdn.com/recipe/20160519/15342_w1024h768c1cx3504cy2338.webp',
  },
  {
    name: 'nature',
    image:
      'https://www.paysdesecrins.com/sites/ot-paysdesecrins/files/styles/ratio_16_9_xl/public/content/images/1608201002-1194303641.jpg?itok=scPgfAgJ',
  },
  {
    name: 'nothing',
    image:
      'https://www.paysdesecrins.com/sites/ot-paysdesecrins/files/styles/ratio_16_9_xl/public/content/images/1608201002-1194303641.jpg?itok=scPgfAgJ',
  },
];

export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
  image{
    asset->{
      url
    }
  },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    } `;

export const pinDetailQuery = (pinId) => {
  const query = `*[_type == "pin" && _id == '${pinId}']{
    image{
      asset->{
        url
      }
    },
    _id,
    title, 
    about,
    category,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
   save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    }
  }`;
  return query;
};

export const pinDetailMorePinQuery = (pin) => {
  const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const searchQuery = (searchTerm) => {
  const query = `*[_type == "pin" && title match '${searchTerm}*' || category match '${searchTerm}*' || about match '${searchTerm}*']{
        image{
          asset->{
            url
          }
        },
            _id,
            destination,
            postedBy->{
              _id,
              userName,
              image
            },
            save[]{
              _key,
              postedBy->{
                _id,
                userName,
                image
              },
            },
          }`;
  return query;
};

export const userQuery = (userId) => {
  const query = `*[_type == "user" && _id == '${userId}']`;
  return query;
};

export const userCreatedPinsQuery = (userId) => {
  const query = `*[ _type == 'pin' && userId == '${userId}'] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const userSavedPinsQuery = (userId) => {
  const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};
